// extracted by mini-css-extract-plugin
module.exports = {"copied":"CopyableText_copied__IKmyv","flash":"CopyableText_flash__c78UR"};